import { useContext } from 'react'
import { useIntl } from 'react-intl'

import LineHeartClickIcon from 'LuxKit/Icons/line/LineHeartClickIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import TripContext from 'tripPlanner/contexts/TripContext'
import { useTrip } from 'tripPlanner/hooks/api/trip'

interface Props {
  className?: string
}

function SuggestedLabel({ className }: Props) {
  const intl = useIntl()
  const tripContext = useContext(TripContext)

  const { data: trip } = useTrip({ tripId: tripContext?.tripId })

  const tripHasChildren = !!trip?.travellerRooms?.some(room => room.childAges.length > 0)

  const recommendedForFamiliesLabel = intl.formatMessage({
    id: 'MflENUflI6ExyUX_nEA_',
    defaultMessage: 'Recommended for families',
    description: 'Label for trip items recommended for families with children',
  })
  const recommendedForYouLabel = intl.formatMessage({
    id: 'mBJZVXrLQUeji12jH5rQ',
    defaultMessage: 'Recommended for you',
    description: 'Form field label for personalized trip item recommendations',
  })

  return (
    <PromotionLabel
      variant="engagement"
      icon={<LineHeartClickIcon />}
      className={className}
    >
      {tripHasChildren ? recommendedForFamiliesLabel : recommendedForYouLabel}
    </PromotionLabel>
  )
}

export default SuggestedLabel
